export function SystemStatusGate({
  mode,
  message,
  children,
  isDebugPath = false,
  session = null,
}) {
  const isSuperAdmin = session?.user?.role === 'super_admin';

  // Always let the debug controller through so mode can be restored.
  if (isDebugPath) {
    return children;
  }

  // Super admins keep full access so they can operate during incidents.
  if (isSuperAdmin) {
    if (mode === 'limited_usage') {
      return (
        <div className="min-h-screen">
          <div className="border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-center text-sm text-amber-950">
            <strong className="font-semibold">Limited usage:</strong>{' '}
            {message?.trim() ||
              'The CRM is running with restricted capacity. Some operations may be slower or unavailable.'}
          </div>
          {children}
        </div>
      );
    }

    return children;
  }

  if (mode === 'under_maintenance') {
    // Allow the login screen so a super admin can sign in and recover.
    if (!session) {
      return (
        <div className="min-h-screen">
          <div className="border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-center text-sm text-amber-950">
            <strong className="font-semibold">Under maintenance</strong>
            {message?.trim() ? ` — ${message.trim()}` : null}
          </div>
          {children}
        </div>
      );
    }

    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
        <div className="max-w-lg rounded-2xl border border-slate-800 bg-slate-900 px-8 py-10 text-center shadow-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-400">
            Under maintenance
          </p>
          <h1 className="mt-3 text-2xl font-semibold text-white">CRM is temporarily offline</h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-300">
            {message?.trim() ||
              'We are performing maintenance. Please check back shortly.'}
          </p>
        </div>
      </div>
    );
  }

  if (mode === 'limited_usage') {
    return (
      <div className="min-h-screen">
        <div className="border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-center text-sm text-amber-950">
          <strong className="font-semibold">Limited usage:</strong>{' '}
          {message?.trim() ||
            'The CRM is running with restricted capacity. Some operations may be slower or unavailable.'}
        </div>
        {children}
      </div>
    );
  }

  return children;
}

export default SystemStatusGate;
